export default __webpack_public_path__ + "static/GraphikWeb-Semibold-e8098c41c038aa39f9833b81e8a86efb.woff2";